// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IJtf","newExpiryDate":"styles_newExpiryDate__1E3vh","footer":"styles_footer__3xDp7"};